export default __webpack_public_path__ + "static/media/koji.6ddccd78.png";